
import { Options, prop, Vue } from "vue-class-component";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import formatNumber from "@/app/infrastructures/misc/common-library/FormatNumber";

class Props {
  min = prop<string | null>({ default: null });
  max = prop<string | null>({ default: null });
}

@Options({
  components: { LpButton },
  emits: ["apply", "reset"]
})
export default class BalanceRangeFilter extends Vue.with(Props) {
  isOpen = false;
  isCurrencyDropdownOpen = false;
  selectedCurrency = "IDR";
  tempMin: string | null = null;
  tempMax: string | null = null;

  created() {
    this.tempMin = this.min ? (formatNumber(this.min) as string) : null;
    this.tempMax = this.max ? (formatNumber(this.max) as string) : null;
  }

  get selectedLabel() {
    if (this.min || this.max) {
      const formattedMin = this.min ? (formatNumber(this.min) as string) : "";
      const formattedMax = this.max ? (formatNumber(this.max) as string) : "";
      if (this.min && this.max) {
        return `${this.selectedCurrency} ${formattedMin} - ${formattedMax}`;
      }
      if (this.min) return `> ${this.selectedCurrency} ${formattedMin}`;
      if (this.max) return `< ${this.selectedCurrency} ${formattedMax}`;
    }
    return "Range saldo";
  }

  get isActive() {
    return this.isOpen || this.min !== null || this.max !== null;
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.tempMin = this.min ? (formatNumber(this.min) as string) : null;
      this.tempMax = this.max ? (formatNumber(this.max) as string) : null;
    }
  }

  toggleCurrencyDropdown() {
    this.isCurrencyDropdownOpen = !this.isCurrencyDropdownOpen;
  }

  selectCurrency(currency: string) {
    this.selectedCurrency = currency;
    this.isCurrencyDropdownOpen = false;
  }

  onInputNumber(key: "tempMin" | "tempMax") {
    const val = this[key];
    if (val) {
      const raw = val.replace(/[^0-9]/g, "");
      this[key] = raw ? (formatNumber(raw) as string) : "";
    }
  }

  reset() {
    this.tempMin = null;
    this.tempMax = null;
    this.$emit("reset");
    this.isOpen = false;
  }

  apply() {
    this.$emit("apply", {
      min: this.tempMin ? this.tempMin.replace(/\./g, "") : null,
      max: this.tempMax ? this.tempMax.replace(/\./g, "") : null,
      currency: this.selectedCurrency
    });
    this.isOpen = false;
  }
}
